// Утилита для работы с буфером обмена и детектирования токенов
class BufferHandler {
    constructor() {
        this.lastClipboardText = '';
        this.isListening = false;
    }

    // Начинает слушать буфер обмена
    startListening() {
        if (this.isListening) return;
        
        this.isListening = true;
        this.checkClipboard();
    }

    // Останавливает прослушивание
    stopListening() {
        this.isListening = false;
    }

    // Проверяет буфер обмена
    async checkClipboard() {
        if (!this.isListening) return;

        try {
            const text = await navigator.clipboard.readText();
            
            // Если текст изменился и похож на адрес токена
            if (text !== this.lastClipboardText && this.isTokenAddress(text)) {
                this.lastClipboardText = text;
                this.onTokenDetected(text);
            }
        } catch (error) {
            // Fallback для старых браузеров или если нет разрешения
            console.log('Clipboard API не доступен:', error);
        }

        // Проверяем каждые 2 секунды
        setTimeout(() => this.checkClipboard(), 2000);
    }

    // Проверяет, похож ли текст на адрес токена
    isTokenAddress(text) {
        if (!text || typeof text !== 'string') return false;
        
        const trimmed = text.trim();
        
        // Содержимое буфера не логируем — туда юзер вставляет адреса кошельков
        
        // Тестируем Solana адрес напрямую
        const testSolanaAddress = '5areqv5tgjj8ubhnprc1wl5kmmijce4fuexcaexubags';
        console.log('🔍 BufferHandler: Testing known Solana address:', testSolanaAddress);
        console.log('🔍 BufferHandler: Known Solana regex test:', /^[1-9A-HJ-NP-Za-km-z]{32,50}$/.test(testSolanaAddress));
        console.log('🔍 BufferHandler: Known Solana length:', testSolanaAddress.length);
        
        // Ethereum-подобные адреса (0x...)
        if (/^0x[a-fA-F0-9]{40}$/.test(trimmed)) {
            console.log('🔍 BufferHandler: Ethereum-like detected');
            return true;
        }
        
        // Solana адреса (Base58 формат) - разная длина
        if (/^[1-9A-HJ-NP-Za-km-z]{32,50}$/.test(trimmed) && !trimmed.startsWith('0x')) {
            console.log('🔍 BufferHandler: Solana detected');
            console.log('🔍 BufferHandler: Solana regex test result:', /^[1-9A-HJ-NP-Za-km-z]{32,50}$/.test(trimmed));
            return true;
        }
        
        // TON адреса
        if (/^[0-9a-zA-Z_-]{48}$/.test(trimmed)) {
            console.log('🔍 BufferHandler: TON detected');
            return true;
        }
        
        // Sui адреса (различные форматы)
        if (/^0x[a-fA-F0-9]{64}$/.test(trimmed) || // Обычный Sui адрес
            /^0x[a-fA-F0-9]{64}::[a-zA-Z0-9_]+::[a-zA-Z0-9_]+$/.test(trimmed)) { // Sui с модулем и функцией
            console.log('🔍 BufferHandler: Sui detected');
            return true;
        }
        
        // Base58 адреса (Bitcoin, Litecoin и др.)
        if (/^[1-9A-HJ-NP-Za-km-z]{26,35}$/.test(trimmed)) {
            console.log('🔍 BufferHandler: Base58 detected');
            return true;
        }

        console.log('🔍 BufferHandler: No match found');
        return false;
    }

    // Callback при обнаружении токена
    onTokenDetected(tokenAddress) {
        // Создаем кастомное событие
        const event = new CustomEvent('tokenDetected', {
            detail: { tokenAddress }
        });
        document.dispatchEvent(event);
    }

    // Получает текущий текст из буфера
    async getCurrentClipboard() {
        try {
            return await navigator.clipboard.readText();
        } catch (error) {
            console.log('Не удалось прочитать буфер обмена:', error);
            return '';
        }
    }

    // Устанавливает текст в буфер
    async setClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (error) {
            console.log('Не удалось записать в буфер обмена:', error);
            return false;
        }
    }
}

export default BufferHandler;